@if ((!isLiveTchat || message.sourceUser?.login !== sourceUser?.login) && message.sourceUser?.login !== previousMessageUser?.login) {
    <app-tchat-user-identity
        class="user"
        [user]="message.source"
        [isCurrentUser]="message.sourceUser?.login === sourceUser?.login"
        [isLiveTchat]="isLiveTchat"></app-tchat-user-identity>
}
<div class="historic-message" [ngClass]="{ 'current-user': message.sourceUser?.login === sourceUser?.login }">
    <div class="historic-message-date">
        @if ((message.date | date: FRENCH_DATE_FORMAT) === (currentDate | date: FRENCH_DATE_FORMAT)) {
            <span>
                {{ message.date | date: 'HH:mm' }}
            </span>
        }
        @if ((message.date | date: FRENCH_DATE_FORMAT) !== (currentDate | date: FRENCH_DATE_FORMAT)) {
            <span>
                {{ message.date | date: FRENCH_DATETIME_WITHOUT_SECONDS_FORMAT }}
            </span>
        }
    </div>
    <span class="historic-message-text">{{ message.text }}</span>
</div>
